import RequestClass from '@api/request/RequestClass';
import {API_NAMESPACE} from '@constants/general';
import type {GetMosaicPostsResponse} from '@interfaces/GetPosts';
import type GetStreamPostsResponse from '@interfaces/GetStreamPostsResponse';

export async function getMosaic(
    clause: string,
    time: number,
    skipIds: string,
    entity?: string,
): Promise<GetMosaicPostsResponse> {
    const base = entity ? `posts/${clause}/${entity}` : `posts/${clause}`;
    return (await new RequestClass(`${API_NAMESPACE}/${base}`)
        .setParams({
            ...(time && {time}),
            ...(skipIds && {skipids: skipIds}),
        })
        .send()) as Promise<GetMosaicPostsResponse>;
}

export async function getStream(
    taxonomy: string,
    term: string,
    time: number,
): Promise<GetStreamPostsResponse> {
    return (await new RequestClass(`${API_NAMESPACE}/posts/stream/${taxonomy}/${term}`)
        .setParams({time})
        .send()) as Promise<GetStreamPostsResponse>;
}
